import { PrimaryButton } from "components/buttons/buttons";
import WorkArea from "components/work-area/work-area";
import { useCallback, useRef, useState } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import usePathNavigate from "../../../../hooks/use-path-navigate";
import { PagoPendienteRespuesta } from "../types/pagos.types";
import PagosDomiciliadosView from "./views/pagos-domiciliados.view";
import PagosPendientesView from "./views/pagos-pendientes.view";
import PagosRealizadosView from "./views/pagos-realizados.view";

const usePagos = () => {
	const pagosSeleccionados = useRef<PagoPendienteRespuesta[]>([]);
	const navigate = usePathNavigate();

	const actualizarSeleccion = useCallback((pagos: PagoPendienteRespuesta[]) => {
		pagosSeleccionados.current = pagos;
	}, []);

	const pagar = (...registros: PagoPendienteRespuesta[]) => {
		if (registros.length === 1) {
			navigate("/:segmento/pagos/individual", { state: registros });
		}
		if (registros.length > 1) {
			navigate("/:segmento/pagos/multiples", { state: registros });
		}
	};

	const pagarSeleccion = () => {
		pagar(...pagosSeleccionados.current);
	};

	return {
		actualizarSeleccion,
		pagarSeleccion
	};
};

const PagosPage = () => {
	const {
		actualizarSeleccion,
		pagarSeleccion
	} = usePagos();

	const [showButton, setShowButton] = useState(true);

	const selectHandler = (eventKey: string | null) => {
		setShowButton(eventKey === "pendientes");
	};

	return (
		<WorkArea title="Pagos" path={["Pagos"]}>
			<div className="row" style={{ maxWidth: 1382 }}>
				<div className="col-12 text-end mt-auto" style={{ minHeight: 40 }}>
					<PrimaryButton hidden={!showButton} onClick={pagarSeleccion}>Pagar selección</PrimaryButton>
				</div>
				<div className="col-12 mt-5">
					<Tabs defaultActiveKey="pendientes" className="nav-Comercio" onSelect={selectHandler}>
						<Tab eventKey="pendientes" title="Pagos pendientes" mountOnEnter>
							<PagosPendientesView onSelectionChanged={actualizarSeleccion} />
						</Tab>
						<Tab eventKey="realizados" title="Pagos realizados" mountOnEnter>
							<PagosRealizadosView />
						</Tab>
						<Tab eventKey="domiciliados" title="Pagos domiciliados" mountOnEnter>
							<PagosDomiciliadosView />
						</Tab>
					</Tabs>
				</div>
			</div>
		</WorkArea>
	);
};

export default PagosPage;